<!--footer section -->
<footer [class]="class" id="footer">
	<!-- <div class="light-layout" *ngIf="newsletter">
		<div class="container">
			<section class="small-section border-section border-top-0">
				<div class="row">
					<div class="col-lg-6">
						<div class="subscribe">
							<div>
								<h4>KNOW IT ALL FIRST!</h4>
								<p>Keep Up To Date With Our Latest Dishes and Offers By Signing Up To Our Newsletter. </p>
							</div>
						</div>
					</div>
					<div class="col-lg-6">
						<form class="form-inline subscribe-form" action="https://pixelstrap.us19.list-manage.com/subscribe/post?u=5a128856334b598b395f1fc9b&amp;id=082f74cbda" target="_blank" method="post">
							<div class="form-group mx-sm-3">
								<input type="email" #name name="EMAIL" id="mce-EMAIL" class="form-control" placeholder="Enter your email">
							</div>
							<button type="submit" class="btn btn-solid">subscribe</button>
						</form>
					</div>
				</div>
			</section>
		</div>
	</div> -->
	<section class="section-b-space light-layout">
		<div class="container">
			<div class="row footer-theme partition-f">
				<!-- <div class="col">
					<div class="sub-title">
						<div class="footer-title">
                            <h4>Opening Hours</h4>
                        </div>
                        <div class="footer-contant">
                            <ul>
                                <li>Monday: Closed</li>
                                <li>Tuesday - Sunday:<br>5pm - 10pm</li>
                            </ul>
                        </div>
					</div>
				</div> -->
				<!-- <div class="col-lg-3 col-md-3 col-6">
					<div class="sub-title">
						<div class="footer-title">
                            <h4>Opening Hours</h4>
                        </div>
                        <div class="footer-contant">
                            <ul>
                                <li>Monday: Closed</li>
                                <li>Tuesday - Thursday: 12-2pm, 5-10pm</li>
                                <li>Friday - Saturday: 12-2pm, 5-11pm</li>
                                <li>Sunday: 12-2pm, 5-10pm</li>
                            </ul>
                        </div>
					</div>
				</div> -->
				<!-- <div class="col">
					<div class="sub-title">
						<div class="footer-title">
                            <h4>Collection Hours</h4>
                        </div>
                        <div class="footer-contant">
                            <ul>
                                <li>Monday: Closed</li>
                                <li>Tuesday - Sunday: 5pm - 9pm</li>
                            </ul>
                        </div>
					</div>
				</div> -->
				<!-- <div class="col-lg-3 col-md-3 col-6">
					<div class="sub-title">
						<div class="footer-title">
						    <h4>Contact</h4>
						</div>
						<div class="footer-contant">
						    <ul class="contact-list">
						        <li><i class="fa fa-map-marker"></i>29 Kneesworth Street, Royston, SG8 5AB
								</li>
						        <li><i class="fa fa-phone"></i>Call Us: 01763 250488</li>
						        <li><i class="fa fa-envelope-o"></i>Email Us: <a>atsiamthairack@gmail.com</a></li>
						    </ul>
						</div>
					</div>
				</div> -->
				<div class="col-lg-2 col-md-2 col-6">
					<div class="sub-title">
						<div class="footer-title">
						    <h4>Terms and Conditions</h4>
						</div>
						<div class="footer-contant">
						    <ul>
                                <li><a [routerLink]="['../terms-conditions']">Terms and Conditions</a></li>
								<li><a [routerLink]="['../privacy-policy']">Privacy</a></li>
						    </ul>
						</div>
					</div>
				</div>
				<div class="col-lg-4 col-md-4 col-6 offset-lg-6" style="display: flex;align-items: flex-end; justify-content: flex-end;">
					<div class="footer-contant">
						<!-- <div class="footer-logo">
							<img [src]="themeLogo" class="footer-logo" alt="logo">
						</div> -->
						<!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, </p> -->
						<div class="footer-social">
                            <ul>
                                <!-- <li>
                                    <a href="https://www.facebook.com/thairackglasshouse" target="_blank"><i class="fa fa-facebook" aria-hidden="true"></i></a>
                                </li> -->
                                <!-- <li>
                                    <a href="javascript:void(0)"><i class="fa fa-google-plus" aria-hidden="true"></i></a>                 
                                </li>
                                <li>
                                    <a href="javascript:void(0)"><i class="fa fa-twitter" aria-hidden="true"></i></a>
                                </li> -->
                                <!-- <li>
                                    <a href="https://www.instagram.com/thairackglasshouseuk/" target="_blank"><i class="fa fa-instagram" aria-hidden="true"></i></a>
                                </li> -->
                                <!-- <li>
                                    <a href="javascript:void(0)"><i class="fa fa-rss" aria-hidden="true"></i></a>
                                </li> -->
                            </ul>
                        </div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<!-- <div class="sub-footer">
		<div class="container">
			<div class="row">
                <div class="col-xl-6 col-md-6 col-sm-12">
                  <div class="footer-end">
                    <p><i class="fa fa-copyright" aria-hidden="true"></i> {{ today | date:'y'}} theme forest powered by pixelstrap</p>
                  </div>
                </div>
                <div class="col-xl-6 col-md-6 col-sm-12">
                  <div class="payment-card-bottom">
                    <ul>
                      <li>
                        <a><img src="assets/images/icon/visa.png" alt=""></a>
                      </li>
                      <li>
                        <a><img src="assets/images/icon/mastercard.png" alt=""></a>
                      </li>
                      <li>
                        <a><img src="assets/images/icon/paypal.png" alt=""></a>
                      </li>
                      <li>
                        <a><img src="assets/images/icon/american-express.png" alt=""></a>
                      </li>
                      <li>
                        <a><img src="assets/images/icon/discover.png" alt=""></a>
                      </li>
                    </ul>
                  </div>
                </div>
            </div>
		</div>
	</div> -->
</footer>
<!--footer section end -->